<script>
import apiArticles from "../../../api/articles";

import { GetDataRequest, FilterColumn } from "../../../components/table";
import { ARTICLE_TYPE_TAG_ID } from "../../constants";

import CategoryField from "./CategoryField.vue";
import { mapGetters } from "vuex";

export default {
  extends: CategoryField,
  computed: {
    ...mapGetters("auth", ["currentWorkShopId"]),
  },
  methods: {
    async loadItems(category_id) {
      const request = new GetDataRequest({
        perPage: 1000,
      });
      request.filterData = [
        new FilterColumn("articles.tag_id", category_id, "="),
        new FilterColumn("articles.is_active", 1, "="),
      ];
      const { data } = await apiArticles.getArticles(this.currentWorkShopId, {
        ...request,
        tag_type: ARTICLE_TYPE_TAG_ID,
      });
      return data.data;
    },
  },
};
</script>